export default "__VITE_ASSET__QUg8gDdK__"